import { SVGProps, Ref, forwardRef } from 'react';

export const ScooterFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M13.694 10.682 11.224 0H8v1.4h2.11l2.178 9.416c-.93.299-1.395 1.012-1.555 1.817H5.267c-.211-1.063-.954-1.966-2.6-1.966C.667 10.667 0 12 0 13.333 0 14.667.667 16 2.667 16c1.646 0 2.389-.903 2.6-1.967h5.466c.211 1.064.954 1.967 2.6 1.967 2 0 2.667-1.333 2.667-2.667 0-1.25-.586-2.499-2.306-2.65"
                    fill="currentColor"
                />
                <path d="M1.333 3.967H6v1.4H1.333z" fill="currentColor" />
                <path d="M8 7.3H3.333v1.4H8z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
ScooterFilledSize16Glyph.displayName = 'ScooterFilledSize16Glyph';
